import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
export default defineComponent({
    name: 'DropdownFilter',
    emits: ['toggle', 'apply'],
    props: {
        title: {
            type: String,
            default: null,
        },
    },
    setup(props, { emit }) {
        const isOpen = ref(false);
        const dropdownRef = ref(null);
        const toggleDropdown = (e) => {
            isOpen.value = !isOpen.value;
            emit('toggle', e);
        };
        const handleClickOutside = (e) => {
            if (isOpen.value &&
                dropdownRef.value &&
                !dropdownRef.value.contains(e.target)) {
                isOpen.value = false;
            }
        };
        onMounted(() => {
            document.addEventListener('click', handleClickOutside);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('click', handleClickOutside);
        });
        return {
            isOpen,
            dropdownRef,
            toggleDropdown,
        };
    },
});
